module.exports = __webpack_public_path__ + "img/loading_v.af8b832e.png";